/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';

const CardLayout = ({ children }) => {
  // In case we might need to use this button again in the future
  const renderCloseButton = () => (
    <div className="d-flex flex-row align-items-end justify-content-end mb-4">
      <span className="me-2 close-btn" role="button" tabIndex="0" onKeyPress={null} onClick={null}>
        <img src="./assets/images/close.svg" alt="close" />
      </span>
    </div>
  );

  return (
    <div className="card-layout px-0 container-md mt-5 mt-md-3 w-100">
      <div className="row mx-0">{children}</div>
    </div>
  );
};

export default CardLayout;

CardLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};
